import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/related-events.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { EventService } from '../../services';

export const loadRelatedEvents$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadRelatedEvents),
      switchMap(({ eventId }) =>
        service.getRelatedEvents(eventId).pipe(
          map(events => actions.LoadRelatedEventsSuccess({ events })),
          catchError(error => of(actions.LoadRelatedEventsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
